// PGYJGData
import React, { FC } from 'react';
import Comma from '../../components/Comma';
import { Image } from '../../components/Image';
import CommonBanner from '../../components/CommonBanner';
import styles from './PGYJG.module.scss';

interface Props {
  PGYJGData: { [key: string]: string };
}
const PGYJG: FC<Props> = (props) => {
  const { PGYJGData } = props;
  const { img, title1, title2, introText1, introText2, logo } = PGYJGData;
  const bannerConfig = {
    bgUrl: img,
    bgCls: 'h-17.5r lg:h-47.5r bg-cover bg-top bg-no-repeat',
    cardCls: '-mt-[40px] lg:-mt-[160px]',
    topBannerModel: 'bg',
  };
  return (
    <section className={styles['pg-yjg-box']}>
      <CommonBanner {...bannerConfig}>
        <div className="py-[15px] lg:py-[40px]">
          <div className={styles['yjg-title-box']}>
            <h2 className={styles['yjg-title']}>{title1}</h2>
            <span className={styles['comma-box']}>
              <Comma />
            </span>
            <h2 className={styles['yjg-title']}>{title2}</h2>
          </div>
          <div className={styles['yjg-intro-text-box']}>
            <p className={styles['yjg-intro-text']}>{introText1}</p>
            <p className={styles['yjg-intro-text']}>{introText2}</p>
          </div>

          <div className={styles['logo-img-box']}>
            <Image objectFit="cover" src={logo} layout="fill" />
          </div>
        </div>
      </CommonBanner>
    </section>
  );
};

PGYJG.displayName = 'PGYJG';
export default PGYJG;
